import { Component } from '@angular/core';
import { Router } from '@angular/router';

@Component({
    selector: 'app-auth-unauthorized',
    template: `
        <div class="unauthorized-container">
            <h2>Access Denied</h2>
            <p>You are not authorized to access this application.</p>
            <p>Please contact your administrator for access.</p>
            <button (click)="tryAgain()" class="retry-button">Try Again</button>
        </div>
    `,
    styles: [
        `
            .unauthorized-container {
                display: flex;
                flex-direction: column;
                align-items: center;
                justify-content: center;
                height: 100vh;
                text-align: center;
            }

            h2 {
                color: #dc3545;
                margin-bottom: 1rem;
            }

            p {
                margin-bottom: 0.5rem;
                color: #6c757d;
            }

            .retry-button {
                margin-top: 1rem;
                padding: 0.5rem 1rem;
                background-color: #007bff;
                color: white;
                border: none;
                border-radius: 4px;
                cursor: pointer;
            }

            .retry-button:hover {
                background-color: #0056b3;
            }
        `
    ]
})
export class AuthUnauthorizedComponent {
    constructor(private router: Router) {}

    tryAgain() {
        // Clear any existing tokens
        document.cookie = 'access_token=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;';
        document.cookie = 'id_token=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;';

        // Redirect to root
        this.router.navigate(['/']);
    }
}
